module.exports = __webpack_public_path__ + "static/media/github-dark.0262c75d.svg";